/** @type {Number} The maximum number of postings to load. */
export const COMPANY_PROFILE__POSTINGS_TO_LOAD_COUNT = 20;

/** @type {Array} The includes for the company. */
export const COMPANY_PROFILE__COMPANY_INCLUDES = [
  'assets.uri-collection',
  'assets.uploader',
  'brands.image',
  'location',
];

export const COMPANY_PROFILE__COMPANY_INCLUDES_ADMIN = [
  'cost-codes',
  'groups',
  'industries',
  'domains',
  ...COMPANY_PROFILE__COMPANY_INCLUDES,
];

export const COMPANY_PROFILE__USER_TEAM_MEMBERSHIP_INCLUDES = [
  'company-membership.company-team-memberships.company-team',
];

/** @type {Array} The includes for the company postings. */
export const COMPANY_PROFILE__POSTINGS_INCLUDES = [
  'assignment-deliverables',
  'assignment-schedules',
  'buyer.company',
  'candidate-location',
  'location',
  'services',
];

export const COMPANY_PROFILE__COMPANY_MANAGEMENT__CARD_DESCRIPTION_LENGTHS = {
  CHARACTER_COUNT_MOBILE: 50,
  CHARACTER_COUNT_MEDIUM_AND_DOWN: 60,
  CHARACTER_COUNT_LARGE_AND_UP: 70,
};
